module.exports = __webpack_public_path__ + "static/home-artist-marketing-2a9a8022433912d30fad2e1521e106e0.webp";